import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Accordion,
  AccordionContent,
  AccordionTitle,
  Button,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  FormCheckbox,
  FormGroup,
  Grid,
  GridColumn,
  GridRow,
  Icon,
  Image,
  Input,
  List,
  ListItem,
  ListList,
  Loader,
  Menu,
  MenuItem,
  Message,
  Modal,
  Popup,
  SemanticWIDTHSNUMBER,
  TextArea
} from 'semantic-ui-react';
import serialExampleImage from './serial_image.png';
import './style.css';
import symptomExampleImage1 from './symptom_image_1.jpg';
import symptomExampleImage2 from './symptom_image_2.jpg';

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

interface Category {
  category: string;
  id: string;
  isActive: boolean;
}

interface Product {
  id: string;
  isActive: boolean;
  product: string;
  category: Category[];
}

interface OptionDetail {
  id: number;
  option: string;
}

interface OptionCategory {
  category: string;
  id: number;
  guide_text?: string;
  detail: OptionDetail[]
}


interface SymptomData {
  id: string;
  symptom_detail: string;
  hasChild: boolean;
  symptom_category: string;
  categoryname: string;
  solution: string;
  selected: boolean;
  guide_text?: string;
  product: string[];
}


interface optionsPair {
  category : OptionCategory;
  detail : OptionDetail;
}

interface WarratyDetail {
  is_warranty: boolean;
  shipment_date?: string;
  warranty_due_date?: string;
  wrranty_period_days?: number;
}

interface DraxModelDetail {
  isSerial: boolean;
  serialNumber : string;
  serialImageUrl: string;
  remark?: string;
  options: number[];
  optionsPair: optionsPair[]
  warrantyDetail?: WarratyDetail;
}

interface DraxModel {
  id: string;
  model: string;
  model_image: string;
  serial_location: string;
  isActive: boolean;
  product: string;
  product_name: string;
  product_obj: Product;
  modelDetail: DraxModelDetail[];
  options: number[];
}

interface FlattenedDraxModelDetail {
  isSerial:boolean;
  modelId: string;
  modelImage: string;
  modelIsActive: boolean;
  modelName: string;
  modelOption: number[];
  modelProduct: string;
  modelSerialLocation?: string;
  options: number[];
  optionsPair: optionsPair[];
  productName: string;
  serialImageUrl: string;
  serialNumber: string;
  serialFile?: File
  selectedFile: FileList;
  isSymptomDetailLocked: boolean;
  symptomDetail: string;
  isSymptomValid: boolean;
  isSymptomDetailValid: boolean;
  isOptionValid: boolean
  isFileValid?: boolean;
  isReceiptValid: boolean;
  isSerialValid: boolean;
  selectedSymptom: SymptomData[];
  warrantyDetail?: WarratyDetail;
}

const Symptoms3 = () => {

  const [flattenedDraxModelDetail, setFlattenedDraxModelDetail] = useState<FlattenedDraxModelDetail[]>([])
  const [optionsData, setOptionsData] = useState<{ [key: string]: OptionCategory[] }>({});

  const [selectedSymptom, setSelectedSymptoms] = useState<SymptomData[] | undefined>(undefined);
  const [activeAccordionIndexList, setActiveAccordionIndexList] = useState<string[]>([]);
  const [open, setOpen] = useState(false); // confirm창 관련
  const [selectedMethod, setSelectedMethod] = useState<'manual' | 'image' | 'qr' | 'unknown'>('manual');
  const serialFileInputRefs = useRef<Map<number, HTMLInputElement>>(new Map());

  const [selectedModelsList, setSelectedModelsList] = useState<DraxModel[]>([]);

  const [selectedModelDict, setSelectedModelDict] = useState<{ [key:string] : DraxModel }>({})
  const [RerenderTrigger, setRerenderTrigger] = useState<number>(0)

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSerialUploaded, setIsSerialUploaded] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState(false);
  const serialFileInputRef = useRef<HTMLInputElement | null>(null);
  const [selectedKey, setSelectedKey] = useState<number>(0); // 모달에서 사용될 key
  const [activeIndex, setActiveIndex] = useState<number>();

  const navigate = useNavigate();

  // 2026-09-21: 고객정보(세션) 없이 이 화면에 들어오면(웹뷰 재시작·중간 화면 직접 진입) 빈 접수가 되므로 고객정보 화면으로 되돌림
  useEffect(() => {
    if (!sessionStorage.getItem('owner') || !sessionStorage.getItem('phone')) {
      alert('고객정보가 없습니다. 고객정보 입력 화면부터 다시 진행해 주세요.');
      navigate('/customer');
    }
  }, [navigate]);


  const selectedModelList = JSON.parse(sessionStorage.getItem('selectedModel') || '[]') as DraxModel[];

  useEffect(() => {
    const storedData = sessionStorage.getItem('selectedModel');

    if (!sessionStorage.getItem('stepThreeStartTime')) {
      const startTime = new Date().toISOString();
      sessionStorage.setItem('stepThreeStartTime', startTime);
    }

    const fetchAllOptions = async (allDraxModelDetails: any[]) => {
      // 각 모델에 대한 options를 병렬로 가져오기
      const result: any = await Promise.all(
          allDraxModelDetails.map(detail =>
              axios
                  .get(`${apiEndpoint}/receiption/api/options/${detail.modelId}`)
                  .then(res => res.data)
          )
      );
      setOptionsData(result);
    };

    const fetchAllData = async () => {
      try {
          if (storedData) {
              const selectedModels: DraxModel[] = JSON.parse(storedData) as DraxModel[];

              // 1) model + detail 을 먼저 평탄화해서 작업 단위 리스트 만들기
              const detailEntries = selectedModels.flatMap(model =>
                  model.modelDetail.map(detail => ({
                      model,
                      detail,
                  }))
              );

              // 2) 각 detail에 대해 비동기 작업 수행 후, 전부 resolve
              const allDraxModelDetails:any = await Promise.all(
                  detailEntries.map(async ({ model, detail }) => {
                      const parentData = {
                          modelId: model.id || '',
                          modelName: model.model || '',
                          productName: model.product_name || '',
                          modelImage: model.model_image || '',
                          modelIsActive: model.isActive || '',
                          modelProduct: model.product || '',
                          modelSerialLocation: model.serial_location || '',
                          modelOption: model.options || '',
                          isOptionValid: model.options.length === detail.optionsPair.length,
                          selectedFile: [],
                          isFileValid: false,
                          isSymptomValid: false,
                      };

                      const symptomsResponse = await axios.get(
                          `${apiEndpoint}/receiption/api/symptom/${model.id}`
                      );
                      const symptomsData: SymptomData[] = symptomsResponse.data.sort(
                          (a: any, b: any) => parseInt(a.id) - parseInt(b.id)
                      );

                      return {
                          ...detail,
                          ...parentData,
                          selectedSymptom: symptomsData || [],
                      };
                  })
              );

              // 이제 여기서는 진짜 "객체 리스트"
              setFlattenedDraxModelDetail(allDraxModelDetails);

              // 3) modelId 가 제대로 있는 상태로 options 요청
              await fetchAllOptions(allDraxModelDetails);
          }
      } catch (e) {
          console.error('Failed to fetch data or parse sessionStorage:', e);
          setSelectedSymptoms(undefined);
          setFlattenedDraxModelDetail([]);
      }
    };

    fetchAllData();
  }, []);


  const genSerialInput = (key:number) => {

    const validateSerialNumber = (serialNumber:any): boolean => {
      // 6~13자리 숫자에서 같은 숫자가 4번 이상 반복되는지 확인하는 함수
      const validateRepeatingNumbers = (serialNumber: string): boolean => {
        // 시리얼 번호에서 최대 13자리까지만 검사
        const numericPart = serialNumber.slice(0, 13);

        // 동일한 숫자가 4번 이상 연속으로 반복되는 패턴을 찾음
        const repeatedDigitPattern = /(\d)\1{3,}/; // (\d): 숫자, \1: 같은 숫자 반복, {3,}: 3번 이상 반복
        return !repeatedDigitPattern.test(numericPart); // 반복 패턴이 있으면 false 반환
      };

      // New validation function for the last 7 digits
      const validateLastSevenDigits = (serialNumber: string): boolean => {
        // 시리얼 번호의 길이가 7보다 짧으면 검사할 수 없으므로 false 반환
        if (serialNumber.length < 7) {
          return false;
        }
        // 마지막 7자리가 모두 숫자인지 확인
        const lastSevenDigits = serialNumber.slice(-7);
        const isNumeric = /^\d{7}$/.test(lastSevenDigits);
        return isNumeric;
      };

      let result = false
      if (serialNumber === '모르겠음') {
        result = true
      } else if (flattenedDraxModelDetail[key].serialFile) {
        result = true
      } else {
        const cond1 : boolean = serialNumber.length >= 6; // 최소 6글자 이상
        const cond2 : boolean = /^\d+$/.test(serialNumber.slice(0, 4)); // 첫 4자리 숫자
        // const cond3 : boolean = /^[a-zA-Z]+$/.test(serialNumber.slice(4,6)); // 4~6자리 문자
        const cond4 : boolean = validateRepeatingNumbers(serialNumber)
        const cond5: boolean = validateLastSevenDigits(serialNumber); // 마지막 7자리 숫자 검사

        result = cond1 && cond2 && cond4 && cond5
      }
      console.log(serialNumber, result)
      return result;
    }

    const genSerialInputDiv = () => {
      const methodOptions = [
        { key: 'manual', text: '직접입력', value: 'manual' },
        { key: 'image', text: '이미지', value: 'image' },
        { key: 'qr', text: 'QR인식', value: 'qr' },
        { key: 'unknown', text: '모르겠음', value: 'unknown' },
      ];

      const handleMethodChange = (e: any, data:any) => {
          setSelectedMethod(data.value);
      };

      const renderItem = (item: any, key: number) => {

        const handleCheckboxChange = (e: any, data: any) => {
          const updatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
            if (index === key) {
              return {
                ...detail,
                serialNumber: data.checked ? '모르겠음' : '', // Use an empty string or null for "not 모르겠음"
                isSerial: data.checked,
                isSerialValid: data.checked,
              };
            }
            return detail;
          });
          setFlattenedDraxModelDetail(updatedList);
        };

        // A single handler for serial number input changes
        const handleSerialInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const value = e.target.value;
          const isValid = validateSerialNumber(value)
          const updatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
            if (index === key) {
              return {
                ...detail,
                isSerial:true,
                serialNumber: value,
                isSerialValid: isValid
              };
            }
            return detail;
          });
          setFlattenedDraxModelDetail(updatedList);
        };

        // Handler for image upload
        const handleSerialImageOnChange = async (e: React.ChangeEvent<HTMLInputElement>, key: number) => {
          const file = e.target.files?.[0] || null;

          if (!file) {
            return;
          }

          const formData = new FormData();
          formData.append('file', file);

          // Optimistically update UI
          const tempUpdatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
            if (index === key) {
              return {
                ...detail,
                serialNumber: '인식 중...',
              };
            }
            return detail;
          });
          setFlattenedDraxModelDetail(tempUpdatedList);

          try {
            const response = await axios.post(
              `${apiEndpoint}/receiption/api/serialOCR/`,
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.extracted_serial_number) {
              if (response.data.data.classification.web_model_data.id !== item.modelId) {
                const tempUpdatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
                  if (index === key) {
                    return {
                      ...detail,
                      isSerial:false,
                      serialFile: null,
                      isSerialImageUploaded: false,
                      serialNumber: '',
                    };
                  }
                  return detail;
                });
                setFlattenedDraxModelDetail(tempUpdatedList);
                alert('선택한 모델의 시리얼이 아닙니다. 다시 한번 확인해주세요.');
                return
              }
              const extracted_serial_number = response.data.extracted_serial_number
              const uploaded_url = response.data.uploaded_url

              // Check if the serial number already exists in the entire list
              const isDuplicate = flattenedDraxModelDetail.some(
                (detail:any, index:number) => detail.serialNumber === extracted_serial_number && index !== key
              );

              if (isDuplicate) {
                alert('이미 추가된 시리얼 번호입니다.');
                return; // Exit the function to prevent further processing
              }

              // Unconditionally store the uploaded image URL
              const finalUpdatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
                if (index === key) {
                  return {
                    ...detail,
                    isSerial:true,
                    isSerialValid:true,
                    serialFile: file, // Clear the file object after upload
                    isSerialImageUploaded: true,
                    serialNumber: extracted_serial_number, // Use the recognized number, or an empty string on failure
                    serialImageUrl: uploaded_url, // Store the URL regardless of OCR success
                    optionsPair: response.data.data.options_selection
                  };
                }
                return detail;
              });
              setFlattenedDraxModelDetail(finalUpdatedList);
            } else {
              document.getElementById(`serial-image-${key}`)!.setAttribute('value', ''); // Reset file input
              alert('시리얼번호 인식에 실패했습니다. 직접 입력해주세요.');
            }

          } catch (error) {
            console.error('OCR failed:', error);

            // Still store the image URL and update the state, but with empty serial number
            const errorUpdatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
                if (index === key) {
                    return {
                        ...detail,
                        serialNumber: '', // Clear serial number on failure
                    };
                }
                return detail;
            });
            setFlattenedDraxModelDetail(errorUpdatedList);
          }
        };
        // Handler for QR scan
        const handleQrScanClick = async (key: number) => { /* ... your logic ... */ };

        // Handler for search button
        const handleSearchSerialButton = async (key: number, serial_number: string) => {
          if (validateSerialNumber(serial_number)) {
            try {
              const response = await axios.get(
                `${apiEndpoint}/receiption/api/serialOCR/${serial_number}`
              );

              if (response.data.data) {
                console.log(response.data.data.options_selection);

                // Create an updated list immutably
                const updatedList = flattenedDraxModelDetail.map((detail, index) => {
                  if (index === key) {
                    // Return a new object with the updated optionsPair
                    return {
                      ...detail,
                      isSerial:true,
                      optionsPair: response.data.data.options_selection,
                    };
                  }
                  return detail;
                });

                alert('조회에 성공하였습니다');
                // Use the state setter function to update the state
                setFlattenedDraxModelDetail(updatedList);
              } else {
                alert('시리얼번호가 조회되지 않았습니다.');
              }
            } catch (error) {
              console.error('API call failed:', error);
              alert('시리얼번호 조회에 실패했습니다.');
            }
          } else {
            alert('적절한 시리얼 규칙이 아닙니다');
          }
        };

        // Handler for cancel image upload
        const handleCancelImageUpload = (key: number) => {
          const updatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
              if (index === key) {
                  return {
                      ...detail,
                      isSerial: false,
                      serialFile: null, // Remove the file object
                      isSerialImageUploaded: false, // Reset upload status
                      serialNumber: '', // Clear the serial number
                      serialImageUrl: '', // Remove the image URL
                      isSerialValid: false, // Reset validation
                      optionsPair: [],
                  };
              }
              return detail;
          });
          setFlattenedDraxModelDetail(updatedList);
        };

        // Determine which UI to show based on the selectedMethod state
        let serialInputUI;
        if (selectedMethod === 'manual') {
            serialInputUI = (
                <>
                  <Grid.Column width={5} style={{ padding: 0 }}>
                      <Input
                          placeholder='시리얼번호'
                          id={`serial-number-${key}`}
                          labelPosition='left'
                          size='mini'
                          className={`p-2 serial-input ${item.isSerialValid ? 'valid-serial' : ''}`}
                          onChange={(e) => handleSerialInputChange(e)}
                          fluid
                          value={item.serialNumber}
                      />
                  </Grid.Column>
                  <Grid.Column className='p-2' width={3}>
                      <Button fluid onClick={() => handleSearchSerialButton(key, item.serialNumber)}>
                          조회
                      </Button>
                  </Grid.Column>
                </>
            );
        } else if (selectedMethod === 'image') {
          if (!item.serialImageUrl) {
            serialInputUI = (
              <Grid.Column width={8} className='p-2' style={{ padding: 0 }}>
              <Button
                icon
                fluid
              >
                <Icon name="file" /> 업로드
              </Button>
              <input
                type="file"
                accept="image/*"
                id={`serial-image-${key}`}
                style={{ display: "none" }}
                onChange={(e) => handleSerialImageOnChange(e, key)}
                onClick={(e) => { (e.target as HTMLInputElement).value = ''; }}
              />
          </Grid.Column>
            )
          } else {
            serialInputUI = (
              <>
                <Grid.Column className='p-2' width={6} style={{ padding: 0 }}>
                  <Button
                    as="label"
                    htmlFor={`serial-image-${key}`}
                    type="button"
                    icon
                    fluid
                    color='orange'
                    disabled
                  >
                  <Icon name="file outline" /> 업로드 완료
                  </Button>
                </Grid.Column>
                <Grid.Column className='p-2' width={2}>
                  <Button
                    fluid
                    icon="close"
                    color="red"
                    size="medium"
                    onClick={() => handleCancelImageUpload(key)}
                  />
                </Grid.Column>
            </>
            )
          }
        } else if (selectedMethod === 'qr') {
            serialInputUI = (
                <Grid.Column width={8} className='p-2' style={{ padding: 0 }}>
                    <Button fluid onClick={() => handleQrScanClick(key)}>
                        <Icon name="qrcode"></Icon>
                        QR 촬영
                    </Button>
                </Grid.Column>
            );
        } else if (selectedMethod === 'unknown') {
            serialInputUI = (
                <Grid.Column width={8} className='p-2' style={{ padding: 0 }}>
                </Grid.Column>
            );
        }

        // Main return statement
        return (
          <Grid className='px-4 py-3' key={key}>
            <Grid.Row>
            <Grid.Column width={2}></Grid.Column>
            <Grid.Column width={4} className='p-2'>
              <Dropdown
                fluid
                selection
                options={methodOptions}
                value={selectedMethod}
                onChange={(e, data) => handleMethodChange(e, data)}
              />
              </Grid.Column>
              {serialInputUI}
            </Grid.Row>
            <Grid.Column width={2}></Grid.Column>
          </Grid>
    );
      };
      return (
        <>
          {renderItem(flattenedDraxModelDetail[key], key)}
        </>
      );
    }

    return <>
      <Divider horizontal>
        <Icon name="key" /><span>시리얼번호(일련번호)</span>
      </Divider>

      <div className="information2 align-center pb-3">
        <p>
          * 시리얼번호(일련번호)를 알 수 없는 경우 <span className='emphasis'>서비스 비용이 청구</span> 될 수 있습니다.
          <br/>
          * 고장접수 시 <span className='emphasis'>시리얼번호를 입력</span> 또는 <span className='emphasis'>촬영</span>해주시면 <span className='emphasis'>더 빠른 접수</span>가 가능합니다.
          <br/>
          * 시리얼번호는 제품의 하단 또는 박스에 부착된 스티커에 있습니다.
        </p>

        <img src={serialExampleImage} alt="Drax" className="py-1" style={{ cursor:'pointer', width: '90%', height: 'auto', maxWidth: '350px'}}/>
      </div>

      <div className={`align-center`}>
        {genSerialInputDiv()}
      </div>

    </>

    }


  const genSerialInputSection = (key:number) => {
    const handleSerialNumberUploadClick = () => {
      const inputElement = serialFileInputRefs.current.get(key);
      if (inputElement) {
          inputElement.click();
      }
    };

    const handleSerialImageOnChange = (e:any) => {
      const file = e.target.files?.[0] || null;
      if (!file) {
        return;
      }
      // Update the state with the selected file
      const updatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
        if (index === key) {
          return {
            ...detail,
            serialFile: file,
            serialNumber: '사진 업로드'
          };
        }
        return detail;
      });
      setFlattenedDraxModelDetail(updatedList);

      // 기존에 선택된 파일 정보를 초기화
      e.target.value = '';
      setRerenderTrigger(prev => prev + 1); // Force re-render to reflect changes
    }

    if (flattenedDraxModelDetail[key].serialFile ? true : false) {
      return <>
        <div className="information2 align-center pb-1">
          <Button color="orange" as="label" type="button" icon>
            <Icon name="file" /> 업로드 완료
          </Button>
        </div>
        <div className="information2 align-center p-1">
          감사합니다.
        </div>
      </>
    } else {
      return  <>
        <div className="information2 align-center pb-3">

          <p>
            * 시리얼번호를 알 수 없는 경우 <span className='emphasis'>서비스 비용이 청구</span> 될 수 있습니다.
            <br/>
            * 시리얼번호를 <span className='emphasis'>촬영</span>해주시면 <span className='emphasis'>더 빠른 접수</span>가 가능합니다.
          </p>
          <img src={serialExampleImage} alt="Drax" className="py-1" style={{ cursor:'pointer', width: '90%', height: 'auto', maxWidth: '350px'}}/>

          <div onClick={handleSerialNumberUploadClick} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',}}>
            <Button color="grey" as="label" type="button" icon>
              <Icon name="file outline" /> 시리얼번호 업로드
            </Button>
            <input
                type="file"
                accept="image/*"
                id={`serial-image-${key}`}
                style={{ display: "none" }}
                ref={el => {
                  if (el) {
                    serialFileInputRefs.current.set(key, el);
                  }
                }}
                onChange={handleSerialImageOnChange}
              />
          </div>
        </div>
      </>
    }
  }

  const toggleGenModelOptionSection = (key:number) => {

    const handleDropDownOnChange = (
      e: any,
      dropdownData: any,
      selectedOptionCategory: OptionCategory,
      key: number
    ) => {

      // 1. Get the newly selected option
      const selectedOptionDetail = selectedOptionCategory.detail.find(
        (detail) => detail.id === dropdownData.value
      );

      if (!selectedOptionDetail) {
        console.error('Selected option not found.');
        return;
      }

      // 2. Create the new optionsPair object
      const newOptionsPair: optionsPair = {
        category: selectedOptionCategory,
        detail: selectedOptionDetail,
      };

      // 3. Update the state immutably
      setFlattenedDraxModelDetail((prevList) => {
        return prevList.map((modelDetail, index) => {
          if (index === key) {
            // If the optionsPair for this category already exists, update it.
            const existingPairIndex = modelDetail.optionsPair.findIndex(
              (pair) => pair.category.id === newOptionsPair.category.id
            );

            let updatedPairs;
            if (existingPairIndex !== -1) {
              // Update the existing pair with the new one.
              updatedPairs = [
                ...modelDetail.optionsPair.slice(0, existingPairIndex),
                newOptionsPair,
                ...modelDetail.optionsPair.slice(existingPairIndex + 1),
              ];
            } else {
              // Add the new pair if it doesn't exist.
              updatedPairs = [...modelDetail.optionsPair, newOptionsPair];
            }

            // Return the new, updated object
            return {
              ...modelDetail,
              optionsPair: updatedPairs,
              isOptionValid: updatedPairs.length === optionsData[key]?.length,
            };
          }
          return modelDetail;
        });
      });
    };

    const genGridColumn = () => {
      const options = optionsData[key]; // Get the options for the current key
      if (!options) {
        // Return null or a loading indicator if the data is not yet available
        // 이 조건문을 통해서 "render before data" 의 문제를 해결할 수 있다.
        return null;
      }

      return (

        options.map((option:OptionCategory) => (
          <GridColumn key={option.id}>
            <div>
              <Popup
                content={<div>{option.guide_text}</div>}
                trigger={<h5 className='pt-3 mb-1'>* {option.category}</h5>}
                style={{padding:'0.75em', fontWeight:"bold", backgroundColor:'#f8f8f8'}}
                size='tiny'
              />
              <Dropdown
                button
                fluid
                placeholder={'-----'}
                options={option.detail.map((e) => ({key:e.id, text:e.option, value:e.id}))}
                value={flattenedDraxModelDetail[key].optionsPair.find(pair => pair.category.id === option.id)?.detail.id || ''}
                disabled={flattenedDraxModelDetail[key].isSerial}
                onChange={(e,data) => handleDropDownOnChange(e, data, option, key)}
                onBlur={(e) => {
                  e.currentTarget.style.backgroundColor='#ffb07bb3';
                  e.currentTarget.style.color='black';
                }}
                onFocus={(e) => {
                  e.currentTarget.style.backgroundColor='';
                  e.currentTarget.style.color='gray';
                }}
                style={{
                  backgroundColor: flattenedDraxModelDetail[key].isSerial ? '#ffb07bb3' : '', // Change color if disabled
                }}
              />
            </div>
          </GridColumn>
        ))
      );
    };

    return <>
      <div>
        <div>
          <Divider horizontal>
            <Icon name="tags" /> 모델 추가정보
          </Divider>
        </div>
        <div className="information2 align-center pb-1">
          <span className='emphasis'>정확한 옵션</span>을 기입하지 않을 경우, <span className='emphasis'>재방문</span>하는 경우가 발생할 수 있습니다.
        </div>
        <div>
          <Grid columns={2 as SemanticWIDTHSNUMBER} className='px-4 py-3'>
            <GridRow>
              {genGridColumn()}
            </GridRow>
          </Grid>
        </div>
      </div>
    </>

  }

  const genSymptomForms = (key:number) => {

    const optionArray = flattenedDraxModelDetail[key].selectedSymptom

    const symptomParentArray = optionArray?.filter((data: SymptomData) => {return data.hasChild === true;}).sort((a, b) => parseInt(a.id) - parseInt(b.id));

    const genSymptomChild = (symptom_category: string, index:number) => {

      const symptomChildData = optionArray?.filter((data: SymptomData) => {return data.symptom_category === symptom_category})

      const sypmtomCheckboxOnclickHandler = (e: any, data: any) => {
        // 1. Get a copy of the flattenedDraxModelDetail array
        const updatedList = [...flattenedDraxModelDetail];

        // 2. Find the specific item to update (using 'key' from the outer scope)
        const itemToUpdate = updatedList[key];
        if (!itemToUpdate) return;

        // 3. Find the specific symptom object within the selectedSymptom array
        const symptomToUpdate = itemToUpdate.selectedSymptom?.find(symptom => symptom.id === data.value);

        if (symptomToUpdate) {
          // 4. Create a new symptom object with the updated 'selected' property
          const updatedSymptom = {
            ...symptomToUpdate,
            selected: data.checked,
          };

          // 5. Create a new selectedSymptom array with the updated symptom
          const newSelectedSymptom = itemToUpdate.selectedSymptom.map(symptom =>
            symptom.id === data.value ? updatedSymptom : symptom
          );

          // 6. Create a new top-level object and assign the new array
          const updatedItem = {
            ...itemToUpdate,
            selectedSymptom: newSelectedSymptom,
            // Pass the NEW symptom list to validateSymptom()
            isSymptomValid: newSelectedSymptom.some(symptom => symptom.selected === true),
          };

          // 7. Replace the old object in the list with the new one
          updatedList[key] = updatedItem;

          // 8. Call the state setter to trigger a re-render
          setFlattenedDraxModelDetail(updatedList);
        }
      };


      const symptomsFormsByCategory = symptomChildData?.map(
        (data: SymptomData) => {
          // Use a more efficient way to get the checked status
          const isChecked = flattenedDraxModelDetail[
            key
          ]?.selectedSymptom?.some((s) => s.id === data.id && s.selected);

          return (
            <>
              <FormCheckbox
                id={`symptom-${key}-${data.id}`}
                className="orange-checkbox"
                value={data.id}
                label={data.symptom_detail}
                checked={isChecked || false}
                symptom_category={data.symptom_category}
                categoryname={data.categoryname}
                name="symptomChild"
                onChange={sypmtomCheckboxOnclickHandler}
                style={{ accentColor: "#e74c3c" }}
              />

              {/* 체크 시 표시되는 추가 안내문 */}
              <label
                htmlFor={`symptom-${key}-${data.id}`}
                style={{ flex: 1, fontWeight: "normal" }}
                onClick={(e) => {
                  // 체크박스 클릭을 시뮬레이션
                  const checkbox = document.getElementById(
                    `symptom-${key}-${data.id}`,
                  ) as HTMLInputElement;
                  if (checkbox && e.target !== checkbox) {
                    checkbox.click();
                  }
                }}
              >
                {!isChecked ? (
                  ""
                ) : (
                  // 체크되었을 때는 symptom_detail + guide_text + solution (하이퍼링크)
                  <>
                    {data.guide_text && (
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#F2711C",
                          paddingLeft: "25px",
                        }}
                      >
                        ({data.guide_text})
                      </span>
                    )}{" "}
                    {data.symptom_detail === "부품구매문의" && (
                      <>
                        <a
                          href="https://smartstore.naver.com/drax"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            color: "green",
                            fontWeight: "bold",
                            textDecoration: "underline",
                            marginLeft: "10px",
                          }}
                        >
                          부품 구매 바로가기
                        </a>
                      </>
                    )}
                    {(data.symptom_detail === "기타" || data.solution) && (
                      <>
                        <a
                          href={
                            data.symptom_detail === "기타"
                              ? "/solutions/"
                              : `/solutions/${data.solution}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            color: "blue",
                            fontStyle: "italic",
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          스스로 해결하기
                        </a>
                      </>
                    )}
                  </>
                )}
              </label>
            </>
          );
        },
      );

      return (
        <>
          <div hidden>{RerenderTrigger}</div>
          <Form>
            <FormGroup grouped unstackable>
              {symptomsFormsByCategory}
            </FormGroup>
          </Form>
        </>
      );
    };

    const AccordionTitleOnclickHandler = (e: any, data: any, tmp:any) => {
      // Create a copy of the current activeAccordionIndexList
      let updatedList = [...activeAccordionIndexList];

      // activeAccordionIndexList에 내가 클릭한 것이 있으면 다시 접기
      if (updatedList.includes(key + '-' + tmp.id)) {

        // + 내부에 클릭 선택된 증상이 있으면 접지 않기
        const tmpElements = document.querySelectorAll(`[id^="symptom-${key}-"`)

        const tmpElements2 = Array.from(tmpElements).filter(data => {
          const parentElement = data.parentElement;
          if (parentElement) {
            return parentElement.getAttribute('symptom_category') === tmp.id.toString();
            }
          });

        if (!Array.from(tmpElements2).map(data => (data as HTMLInputElement).checked).includes(true)) {
          // If the index is in the list, remove it
          updatedList = updatedList.filter(i => i !== key + '-' + tmp.id);
        }
      } else {
        // If the index is not in the list, add it
        updatedList.push(key + '-' + tmp.id);
      }

      // Update the state with the new list
      setActiveAccordionIndexList(updatedList);
    };

    return (
      <>
      <Divider horizontal>
        <Icon name="wrench" />고장증상
      </Divider>
      <div>
        <Accordion as={Menu} vertical fluid exclusive={true}>
        {symptomParentArray?.map((data, index) => (
          <MenuItem active={activeAccordionIndexList.includes(key + '-' + data.id)}>
            <AccordionTitle
              className='emphasis'
              content={`${data.symptom_detail}`}
              active={activeAccordionIndexList.includes(key + '-' + data.id)}
              index={index}
              onClick={(e,d) => AccordionTitleOnclickHandler(e,d,data)}
            />
            <AccordionContent
              active={activeAccordionIndexList.includes(key + '-' + data.id)}
              content={genSymptomChild(data.id, index)}
            />
            </MenuItem>
        ))}
        </Accordion>
      </div>
      </>
    )
  }

  const genSymptomUpload = (key:number) => {

    const handleUploadClick = (key:number, e:any) => {
      setOpenModal(true); // 모달 먼저 띄움
      setSelectedKey(key)
    };

    const handleModalConfirm = (key:number, e:any) => {
      setOpenModal(false);

      document.getElementById(`image-file-${key}`)?.click(); // 모달 닫고 파일 업로드 창 띄움
    };

    const genSelectedFilesNames = () => {

      const fileDeleteHandler = (e: any, index: number) => {
        if (flattenedDraxModelDetail[key].selectedFile) {
          const updatedFiles = Array.from(flattenedDraxModelDetail[key].selectedFile).filter((_, i) => i !== index);

          const dataTranfer = new DataTransfer();
          updatedFiles.forEach(file => dataTranfer.items.add(file));
          flattenedDraxModelDetail[key].selectedFile = dataTranfer.files

          setFlattenedDraxModelDetail(flattenedDraxModelDetail)
          setRerenderTrigger(RerenderTrigger +1)
        }

        flattenedDraxModelDetail[key].isFileValid = flattenedDraxModelDetail[key].selectedFile?.length !== 0 || false
      }

      const fileNameList: string[] = [];
      const selectedFiletestList = flattenedDraxModelDetail[key].selectedFile
      if (selectedFiletestList){
        if (selectedFiletestList.length !== 0) {

        Array.from(selectedFiletestList).forEach((file,index) => fileNameList.push(`[${file.type.split('/')[0]}] ${index}. ${file.name.split('.')[0]} `))

        return (<>
            <div hidden>{RerenderTrigger}</div>
            <div id='file-list' className='card m-3 p-3'>
              업로드된 파일
              <List>
                {fileNameList.map((data,index) => (
                  <ListItem className='m-1'>
                    <Button circular icon="delete" size='mini' className='smaller' onClick={(e) => fileDeleteHandler(e, index)}></Button> {data}
                  </ListItem>
                ))}
              </List>
            </div>
          </>
        )}
      }

    }

    const handleSelectFileList = (e:any) => {
      flattenedDraxModelDetail[key].selectedFile = e.target.files
      flattenedDraxModelDetail[key].isFileValid = true

      // genSelectedFilesNames이 rerendering되도록 하기 위한 trigger. 트릭이다.
      setRerenderTrigger(RerenderTrigger +1)

    }

    return <>
      <Divider horizontal>
        <Icon name="cloud upload" /> 증상업로드(이미지/동영상)
      </Divider>

      <div>
        {/* 업로드 버튼 */}
        <div className="information2 align-center pb-2">
          <Button color='grey' type="button" icon onClick={(e) => handleUploadClick(key, e)}>
            <Icon name='file outline'></Icon> 증상 업로드
          </Button>
        </div>

        {/* 참고 : https://stackoverflow.com/questions/55464274/react-input-type-file-semantic-ui-react */}
        {/* <div className="information2 align-center pb-2">
          <Button color='grey' as="label" htmlFor={`image-file-${key}`} type="button" icon >
            <Icon name='file outline'></Icon> 업로드
          </Button>
        </div> */}
      </div>

      <input
        type="file"
        multiple
        accept="image/*, video/*"
        id={`image-file-${key}`}
        style={{ display: "none" }}
        onClick={(e) => { (e.target as HTMLInputElement).value = ''; }}
        onChange={handleSelectFileList}
      />

      {/* 업로드 가이드 모달 */}
      <Modal
        size="small"
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <Modal.Header>업로드 가이드</Modal.Header>
        <Modal.Content scrolling>
          <div style={{ fontSize: '1rem', lineHeight: '1.5' }}>
            <List>
              <ListItem><h2>📷 사진 제출 가이드</h2>
                <ListList>
                  <ListItem>- <span className="emphasis">제품의 전면 및 측면</span>이 잘 보이도록 전체 외관을 촬영해 주세요.</ListItem>
                  <ListItem>- 파손, 마모, 소음 등 이상이 <span className="emphasis">발생한 부위의 확대 사진</span>을 포함해 주세요.</ListItem>
                  <Message>
                    <Grid columns={2} stackable>
                      <Grid.Row>
                        <Grid.Column>
                          <Image src={symptomExampleImage1} fluid rounded />
                        </Grid.Column>
                        <Grid.Column>
                          <Image src={symptomExampleImage2} fluid rounded />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>

                  </Message>
                </ListList>
              </ListItem>

              <ListItem><h2>🎥 동영상 제출 가이드</h2>
                <ListList>
                  <ListItem>- 소음, 작동 불량, 멈춤 현상 등을 실제로 촬영해 주세요.</ListItem>
                  <ListItem>- 시작부터 종료까지 <span className="emphasis">약 10~30초 분량 권장</span></ListItem>
                  <ListItem>- 버튼 입력 후 반응 여부 또는 화면 변화 등을 확인할 수 있는 영상을 촬영해 주세요.</ListItem>
                  <Message>
                    <Grid columns={2} stackable>
                      <Grid.Row>
                        <Grid.Column>
                          <video
                            src="/videos/symptom_video_1.mp4"
                            controls
                            style={{ width: '100%', borderRadius: '8px' }}
                          />
                        </Grid.Column>
                        <Grid.Column>
                          <video
                            src="/videos/symptom_video_2.mp4"
                            controls
                            style={{ width: '100%', borderRadius: '8px' }}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Message>
                </ListList>
              </ListItem>
            </List>

            <p>
                * 제품의 문제 증상을 명확하게 보여줄 수 있도록 촬영해주세요.
                <br />
                * 특히 <span className="emphasis">소음</span>의 경우에는 <span className="emphasis">동영상</span> 업로드가 효과적입니다.
                <br />
                <br />
                감사합니다.
            </p>

          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenModal(false)}>취소</Button>
          <Button color='blue' onClick={(e) => handleModalConfirm(selectedKey, e)}>확인하고 업로드</Button>
        </Modal.Actions>
      </Modal>

      <div>
        {genSelectedFilesNames()}
      </div>
    </>
  }

  const genSymptomDetail = (key:number) => {

    const handleDetailSymptom = (e:any ,data:any) => {
      if (!flattenedDraxModelDetail[key].isSymptomValid){
        alert('1개 이상의 고장증상을 선택해주세요')
      } else {
        const updatedList = flattenedDraxModelDetail.map((detail:any, index:number) => {
        if (index === key) {
          return {
            ...detail,
            symptomDetail: e.target.value,
            isSymptomDetailValid: e.target.value ? true : false
          }}
          return detail;
        });
      setFlattenedDraxModelDetail(updatedList);
      }
    }

    return (
      <>
      <Divider horizontal>
        <Icon name="pencil alternate" /> 상세증상
      </Divider>
      <div hidden>{RerenderTrigger}</div>
      <div>
        <Form>
        <TextArea
          placeholder="상세증상을 입력하세요."
          value={flattenedDraxModelDetail[key].symptomDetail}
          onInput={handleDetailSymptom}
          disabled={flattenedDraxModelDetail[key].isSymptomDetailLocked}
        />
        </Form>
      </div>
      </>
    );
  }

  const genFoldableCard = () => {

      const genModelCard = () => {
        const handleClick = (e: React.MouseEvent, titleProps: any) => {
          const { index } = titleProps;
          const newIndex = activeIndex === index ? -1 : index;
          setActiveIndex(newIndex);

          // scroll to the clicked accordion, but with a delay, so that the accordion can expand first
          setTimeout(() => {
            document.getElementById(`accordion-title-${index}`)?.scrollIntoView({behavior: "smooth", block:"start"});
          }, 100);

        }

        // console.log(flattenedDraxModelDetail)
        const genAccordionTitleText = (index: number) => {
          const item = flattenedDraxModelDetail[index];

          return (
            <>
              {Number(index) + 1}.
              [{item.productName}]
              {item.modelName}

              {/* Conditional rendering based on isSerial */}
              {item.isSerial ? (
                // Case 1: isSerial is TRUE
                <> - {item.serialNumber}</>
              ) : (
                // Case 2: isSerial is FALSE (Check for serialFile)
                item.serialFile ? (
                  // Case 2a: serialFile exists
                  ' - 시리얼이미지 업로드'
                ) : (
                  // Case 2b: serialFile does NOT exist
                  ''
                )
              )}

            {item.warrantyDetail && item.warrantyDetail.is_warranty ?
            <span
              style={{
                      backgroundColor: '#DFF6DD',
                      color: '#388E3C',
                      padding: '1px 10px',
                      borderRadius: '12px',
                      fontWeight: 'bold',
                      fontSize: '0.92em',
                      marginLeft: '12px',
                      border: '1px solid #A5D6A7',
                      display: 'inline-block'
              }}
            >보증</span>
             : ''}
            </>
          );
        };

        const genAccordion = flattenedDraxModelDetail.map((data:FlattenedDraxModelDetail, index:number) => {
          return <>
          <div className='card mt-0 mb-0'>
            {/* title 부분 */}
            <AccordionTitle id={`accordion-title-${index}`} active={activeIndex === index} index={index} onClick={(e,d) => handleClick(e,d)}>
              <h3>
                <Icon name='dropdown' />
                {genAccordionTitleText(index)}
              </h3>
            </AccordionTitle>

            {/* content 부분 */}
            <AccordionContent active={activeIndex === index}>
              {data.isSerial  ? '' : genSerialInputSection(index)}
              {toggleGenModelOptionSection(index)}
              {genSymptomForms(index)}
              {genSymptomUpload(index)}
              {genSymptomDetail(index)}
            </AccordionContent>
            </div>
          </>
        })
        return <>
          {genAccordion}
        </>
      }

      return <>
      <div className='card'>
        <h2 className="mt-2 mb-5 align-center">모델 정보 및 증상 입력(dev)</h2>
        <Accordion fluid defaultActiveIndex={0} exclusive={true}>
          {genModelCard()}
        </Accordion>
      </div>

  </>
  }


  const genConfirmSection = () => {

    // "접수완료" 버튼 클릭
    const handleRealFinishReceipt = async () => {

        setIsLoading(true);
        const lastDataTransferTime = new Date().toISOString();
        sessionStorage.setItem('receiptionEndTime', lastDataTransferTime)

        const formData = new FormData();
        formData.append('receiptData', JSON.stringify(flattenedDraxModelDetail))
        formData.append('customerData', JSON.stringify(sessionStorage));
        formData.append('companyRegisterPaper', JSON.stringify(sessionStorage.getItem('savedCompanyRegisterPaper')))
        formData.append('onReceipt', JSON.stringify(sessionStorage.getItem('onReceipt')));

        flattenedDraxModelDetail.forEach((data, key) => {
          const fileList = flattenedDraxModelDetail[key].selectedFile;
          for (let i = 0; i < fileList.length; i++) {
            const element = fileList[i];
            formData.append(`file_${key}`,element)
          }

          if (flattenedDraxModelDetail[key]?.serialFile) {
            formData.append(`serial_file_${key}`, flattenedDraxModelDetail[key].serialFile!);
          }
        });

        await axios.post(`${apiEndpoint}/receiption/api/kakaoReceipt/`, formData, {
            headers: {'Content-Type': 'multipart/form-data',},
            }).then(response => {
                setIsLoading(false);
                sessionStorage.clear()
                toast.success('접수완료 되었습니다.', { autoClose: 3000 });

                // 접수완료 후 설문조사 페이지로 이동(5초후) 10/21종료
                // setTimeout(() => {
                //   window.location.href = 'https://forms.gle/vFnPGq9VLtbGqKxF6'
                // }, 5000)

                navigate('/')

              })
              .catch(error => {
                setIsLoading(false);
                console.error('API 호출 중 오류 발생:', error);
                toast.error((error && error.response && error.response.data && error.response.data.message) || '접수 중 오류가 발생했습니다.');
                });

    };

    // 사업자등록번호 포멧팅 코드
    const companySerial = sessionStorage.getItem('companySerial');

    const isValidSerial = (serial: string | null): boolean => {
        return serial !== null && /^\d{10}$/.test(serial);
    }

    const formatSerial = (serial: string): string => {
        return `${serial.slice(0, 3)}-${serial.slice(3, 5)}-${serial.slice(5)}`;
    }

    const formattedSerial = isValidSerial(companySerial) ? formatSerial(companySerial as string) : '없음';

    const weekdayOrder = ['월', '화', '수', '목', '금', '토', '일'];
    const sortedClosedDays = sessionStorage.getItem('closedDays')?.split(',')
      .sort((a, b) => weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b))
      .join(', ') ?? '';

    // 입력내용 최종 확인!!
    const handleFinishReceiptButtonClick = () => {
      // 확인해야할 것들.
      // 1. 시리얼번호 => 시리얼번호 입력 or 모르겠음
      // 2. 모델 추가정보 입력
      // 3. 고장증상 선택
      // 4. 증상 파일 업로드
      // 5. 상세증상 입력

      flattenedDraxModelDetail.forEach((data, key) => {
        // const isSymptomDetailValid = data.
        const isValid = flattenedDraxModelDetail[key].isFileValid &&
          flattenedDraxModelDetail[key].isOptionValid &&
          flattenedDraxModelDetail[key].isSymptomValid &&
          flattenedDraxModelDetail[key].isSymptomDetailValid;
        flattenedDraxModelDetail[key].isReceiptValid = isValid || false
      })

      const genAlertStr = () => {
        const invalidReceiptList = flattenedDraxModelDetail.filter(data => !data.isReceiptValid)
        let resStr = ''


        invalidReceiptList.forEach((data, key) => {
          const serialNumberStr = data.isSerial ? ` - sn.${data.serialNumber}` : ''

          resStr += `${key+1}.[${data.productName}]${data.modelName}${serialNumberStr}\n`
          if (!data.isOptionValid) {resStr += '* 추가옵션을 모두 선택해주세요.\n'}
          if (!data.isSymptomValid) {resStr += '* 고장증상을 선택해주세요.\n'}
          if (!data.isFileValid) {resStr += '* 고장증상과 관련된 파일을 업로드해주세요.\n'}
          if (!data.isSymptomDetailValid) {resStr += '* 상세증상을 입력해주세요.\n'}
          resStr += '\n'
        })

        return resStr.trimEnd()
      }

      const isTotalValid = Object.values(flattenedDraxModelDetail).filter(data => !data.isReceiptValid).length === 0
      if (!isTotalValid) {
        alert(genAlertStr())
      } else {
        setOpen(true)
      }
    }

    // selectedSymptomDict
    const genFinalCheckStr = Object.keys(flattenedDraxModelDetail).map((key, index) => {
      const data = flattenedDraxModelDetail[index]
      const serial = `${data.serialNumber}` ? data.serialNumber : '미입력'
        return <>
          <h5>접수번호 - {index+1}</h5>
          <div>
            <ul>
              <li> * 모델 : [{data.productName}]{data.modelName}</li>
              <li> * 시리얼번호 : {serial}</li>
              <li> * 상세증상 : {data.symptomDetail}</li>
            </ul>
          </div>
        </>
      })

    return (
      <div>
            <Button color='grey' className="p-3" onClick={() => navigate('/models/')}>이전</Button>
            <Button color='orange' onClick={handleFinishReceiptButtonClick} className="p-3">접수완료</Button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                size='small'
            >
                <Modal.Header><h2>서비스 접수 확인</h2></Modal.Header>
                <Modal.Content>
                <h5>아래와 같이 접수를 완료하시겠습니까?</h5>

                <h5>&lt;고객정보&gt;</h5>
                <p>
                  * 고객명/ 상호명: {sessionStorage.owner}<br></br>
                  * 접수자: {sessionStorage.receiptName}<br></br>
                  * 전화번호: {sessionStorage.phone}<br></br>
                  * 사업자등록번호: {formattedSerial}<br></br>
                  * 주소: {sessionStorage.address}, {sessionStorage.addressDetail}<br></br>
                  * 휴무일: {sortedClosedDays}<br></br>
                  * 요청사항 : {sessionStorage.customerRequest}<br></br>
                  <Divider />

                  {genFinalCheckStr}
                </p>
                <Divider />

                <div>* 기본출장비 : <span className='emphasis'>44,000원</span>(부가세포함)</div>
                <div>* <span className='emphasis'>유상기간</span>의 제품인 경우 <span className='emphasis'>출장비(44,000원)</span>과 <span className='emphasis'>부품비</span>가 발생됩니다.</div>
                <div>* 입력하신 정보가 <span className='emphasis'>정확하지 않을 경우</span> 또는 <span className='emphasis'>타사 제품</span>인 경우 <span className='emphasis'>출장비(44,000원)</span>가 발생될 수 있으며 <span className='emphasis'>재방문으로 인해 서비스가 지연</span>될 수 있음을 알려드립니다.</div>
                <div>* <span className='emphasis'>보증기간이 경과된 제품</span> 또는 보증기간 내라도 <span className='emphasis'>고장이 아니거나 사용자 과실</span>인 경우 <span className='emphasis'>유상 청구</span>될 수 있습니다.</div>
                <div>* <span className='emphasis'>소모품 교체</span>는 <span className='emphasis'>스마트스토어</span>를 통해 간단히 해결할 수 있습니다.<a href="https://smartstore.naver.com/drax" target="_blank" rel="noreferrer">(스마트스토어로 이동하기)</a></div>
                <div>* <span className='emphasis'>접수취소</span>는 <span className='emphasis'>접수내역확인</span> 페이지에서 가능합니다.</div>
                </Modal.Content>
                <Modal.Actions>
                <Button onClick={() => setOpen(false)}>
                    취소
                </Button>
                <Button onClick={handleRealFinishReceipt} color='orange'>
                    접수 완료
                </Button>
                </Modal.Actions>
            </Modal>
          </div>
    )
  }


  const loading = () => {
    return (
      <>
      <div className="loading-container">
        <Dimmer active>
            <Loader size='big'>
              <div className='p-1'>접수중입니다...</div>
              <div className='p-1'>잠시만 기다려주세요</div></Loader>
        </Dimmer>
      </div>
      </>
    )
  }

  return (
    <>
    {isLoading ? loading() : null }

    {genFoldableCard()}

      {/* ------------------버튼----------------- */}
      <div className="row">
        <div className="align-center col">
          {genConfirmSection()}
        </div>
      </div>
    </>
  );
}

export default Symptoms3;